import React, {ReactNode} from 'react';
import SearchableSelect, {OptionType, SearchableSelectOwnProps, SelectOptionTypes} from "./SearchableSelect";
import { UserViewSettingsProp, ViewIdentifiable} from "../../models/common/ViewSettings";
import {fetchSelectOptions, SelectIdentifiable} from "../../actions/common/SelectActions";
import {SelectState, SelectStateByIdentifier} from "../../reducers/common/SelectReducer";
import { Props as SelectProps } from 'react-select';
import { Props as AsyncProps } from 'react-select';
import {  ActionMeta, InputActionMeta } from 'react-select';
import {LanguageProp} from "../../config/LanguageConfig";
import {Nullable} from "../../models/common/Nullable";
import {Denseable} from "../../models/common/ComponentBehavioural";

export interface AsyncSelectOwnProps< T extends OptionType > extends ViewIdentifiable, SelectIdentifiable, Partial<LanguageProp>, Partial< UserViewSettingsProp >, Denseable {
    selectState: Nullable< SelectState<T> >
    route: string
    label: string
    required?: boolean
    selectClassName?: string
    onSelectChange?: ( value: SelectOptionTypes<T>, action: ActionMeta<T> ) => void
    onUserInputChange: typeof fetchSelectOptions
    helperText?: ReactNode
    error?: { hasError: boolean, message: ReactNode }
}

export type AsyncSelectProps< T extends OptionType = OptionType > = AsyncSelectOwnProps<T> & SelectProps< T > | AsyncSelectOwnProps<T> & AsyncProps< T >

/**
 * AsyncSelect fetches select options from backend and refetches on user typing
 *
 * @param props
 * @constructor
 */
function AsyncSelect<T extends OptionType = OptionType >( props: AsyncSelectProps< T > ) {

    const {
        route,
        onUserInputChange,
        selectState,
        selectIdentifier ,
        userViewSettings
    } = props;

    const inputChangeHandler = ( newValue: string, actionMeta: InputActionMeta ) => {
        if( actionMeta.action === "input-change"  && selectState !== null ) {
            onUserInputChange(
                selectIdentifier,
                route,
                {...selectState.selectSettings, searchValue: newValue}
            );
        }
    };

    return (
        <SearchableSelect
            {...props}
            onInputChange={inputChangeHandler}
            options={ selectState?.currentOptions ?? [] }
            isLoading={ selectState?.request?.isFetching ?? false }
            isAsync
        />

    );
}

export default AsyncSelect;